<template>
  <div class="absolute bottom-[24] right-[46] z-[10] dg-status-tip">
    <p class="w-[50] text-right cursor-pointer">
      <img src="../assets/img/help.png" class="w-[40]" alt="" />
      <!-- <i class="icon t-[30] t-[#B3C8FF]">&#xe73d;</i> -->
    </p>
    <div class="w-[297] gradual px-[20] t-[#606266] t-[12] pt-[28] pb-[36] absolute bottom-[2] right-[42] rounded-[4] border-[1] border-[#fff] border-solid">
      <div class="pb-[16]" v-for="(v, index) in statusTip" :key="index">
        <p class="t-[#000] t-[14] pb-[6]" v-if="v.title">{{ v.title }}</p>
        <p class="pl-[10] tag relative pb-[5]" v-for="(item, index) in v.child" :key="index">
          <span class="t-[#303133]">{{ item.name }}</span
          >{{ item.txt }}
        </p>
        <!-- <p class="pl-[10] tag relative pb-[5]"><span class="t-[#303133]">占用：</span>对应上游企业正在使用该账款进行融资，但未发生债权转让。</p>
        <p class="pl-[10] tag relative pb-[5]"><span class="t-[#303133]">已转让：</span>对应上游企业正在使用该账款进行融资，债权已转让。</p> -->
      </div>
    
    </div>
  </div>
</template>
<script>
export default {
  name: "dg-status-tip",
  props: {
    statusTip: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style lang="less" scoped>
@import '~@/assets/css/var.less';
.gradual {
  background: linear-gradient(180deg, #f4f6f8 0%, #ffffff 100%);
  box-shadow: 0 0px 9px 3px rgba(0, 0, 0, 0.12);
}
.tag {
  &::after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    background-color: #d9d9d9;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 5px;
  }
}
.dg-status-tip {
  .gradual {
    display: none;
  }
  &:hover {
    .gradual {
      display: block;
    }
  }
}
</style>
 <style>.bottom-\[24\] {
    bottom: 24px
}
.right-\[46\] {
    right: 46px
}
.z-\[10\] {
    z-index: 10
}
.w-\[50\] {
    width: 50px
}
.w-\[40\] {
    width: 40px
}
.t-\[30\] {
    font-size: 30px
}
.t-\[\#B3C8FF\] {
    color: #B3C8FF
}
.w-\[297\] {
    width: 297px
}
.px-\[20\] {
    padding-left: 20px;
    padding-right: 20px
}
.t-\[\#606266\] {
    color: #606266
}
.t-\[12\] {
    font-size: 12px
}
.pt-\[28\] {
    padding-top: 28px
}
.pb-\[36\] {
    padding-bottom: 36px
}
.bottom-\[2\] {
    bottom: 2px
}
.right-\[42\] {
    right: 42px
}
.rounded-\[4\] {
    border-radius: 4px
}
.border-\[1\] {
    border-width: 1px
}
.border-\[\#fff\] {
    border-color: #fff
}
.pb-\[16\] {
    padding-bottom: 16px
}
.t-\[\#000\] {
    color: #000
}
.t-\[14\] {
    font-size: 14px
}
.pb-\[6\] {
    padding-bottom: 6px
}
.pl-\[10\] {
    padding-left: 10px
}
.pb-\[5\] {
    padding-bottom: 5px
}
.t-\[\#303133\] {
    color: #303133
}
.absolute {
    position: absolute
}
.text-right {
    text-align: right
}
.cursor-pointer {
    cursor: pointer
}
.border-solid {
    border-style: solid
}
.relative {
    position: relative
}</style>